export namespace DriverStatusConstants {
  export const NONE: string = 'None';
  export const PERIOD_ONE: string = 'Period 1';
  export const EN_ROUTE: string = 'Driver en route';
  export const PICK_UP_ARRIVED: string = 'Pick-up arrived';
  export const IN_PROGRESS: string = 'In progress';
  export const DROP_OFF_ARRIVED: string = 'Drop-off arrived';
}
